import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
const questionContainerCss = "qkhikjn";
const QuestionContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(questionContainerCss, props.className)} />;
});
const answerContainerCss = "aqd04qi";
const AnswerContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(answerContainerCss, props.className)} />;
});
export const Question = ({
  name,
  values
}) => <div>
    <QuestionContainer>
      <BodyText weight="semibold">{name}</BodyText>
    </QuestionContainer>
    <AnswerContainer>
      {values.map(value => <BodyText key={value}>
          {value}
        </BodyText>)}
    </AnswerContainer>
  </div>;

require("./question.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./question.js");